import { render, staticRenderFns } from "./SalesAndExpense.vue?vue&type=template&id=00d8195c&"
import script from "./SalesAndExpense.vue?vue&type=script&lang=js&"
export * from "./SalesAndExpense.vue?vue&type=script&lang=js&"
import style0 from "./SalesAndExpense.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports